/**
 * Copyright (c) 2017-present, Tomaruba, Inc.
 * All rights reserved.
 */
import NProgress from 'nprogress'
import { Component } from 'react'
import { Container } from 'flux/utils'
import { withRouter } from 'react-router'
import StripeKeysStore from '../../store/stripe_key/StripeKeysStore'
import SessionStore from '../../store/SessionStore'
import ListView from '../../view/pages/stripe_key/ListView'
import HotelOptionsStore from '../../store/options/HotelOptionsStore'
import StripeKeySearchStore from '../../store/stripe_key/StripeKeySearchStore'
import StripeKeyAction from '../../action/stripe_key'
import SessionAction from '../../action/session'
import StripeKeyPaginationStore from '../../store/stripe_key/StripeKeyPaginationStore'

class ListContainer extends Component {
  static getStores() {
    return [StripeKeysStore, SessionStore, HotelOptionsStore, StripeKeySearchStore, StripeKeyPaginationStore]
  }

  static calculateState(prevState, props) {
    return {
      session: SessionStore.getState(),
      hotel_options: HotelOptionsStore.getState(),
      search: StripeKeySearchStore.getState(),
      stripe_keys: StripeKeysStore.getState(),
      pagination: StripeKeyPaginationStore.getState(),
      ...props
    }
  }

  async componentDidMount() {
    NProgress.start()
    await StripeKeyAction.onSearch(this.state.search, this.state.pagination)
    await SessionAction.fetchUserHotels()
    NProgress.done()
  }

  render() {
    return ListView(this.state)
  }
}

export default withRouter(Container.create(ListContainer, { withProps: true }))
